export enum FinaOpenBankingConsentStatus {
    Unknown = "Unknown",
    Created = "Created",
    Imported = "Imported",
    Expired = "Expired",
    Invalid = "Invalid",
}

export enum FinaComputedConsentStatus {
    NotRequired = "NotRequired",
    NotProvided = "NotProvided",
    Provided = "Provided",
    Expired = "Expired",
    ExpiresSoon = "ExpiresSoon",
}

export type PayoutInformationBank = {
    bic: string;
    externalBankId: string | null;
    id: number;
    name: string;
};

export type PayoutInformationBankConsent = {
    accounts: PayoutInformationAccount[];
    bank: PayoutInformationBank;
    inProgressConsentIds: number[];
};

export type PayoutInformationAccount = {
    accountName: string | null;
    accountNumber: string;
    bank: PayoutInformationBank;
    consentExpiresAt: string | null;
    consentStatus: FinaComputedConsentStatus;
    currency: string;
    customerPaymentMethodId: number | null;
    isExpressPaymentMethod: boolean;
    isPayoutAccount: boolean;
    isPrimary: boolean;
    openBankingAccountId: number | null;
    supportedCurrencies: string[];
    userName: string | null;
};

export type PayoutInformation = {
    accounts: PayoutInformationAccount[];
    bankConsents: PayoutInformationBankConsent[];
};

export type SavePayoutInformationAccountRequest = {
    customerPaymentMethodId: number | null;
    isPayoutAccount: boolean;
    isPrimary: boolean;
    openBankingAccountId: number | null;
    supportedCurrencies: string[];
};

export type PayoutInformationConsentStatus = {
    externalErrorMessages: string[];
    id: number;
    status: FinaOpenBankingConsentStatus;
};
